import { useCallback, useMemo } from 'react';

export const useScrollToTopConversations = () => {
  const handleScroll = useCallback(
    ({
      direction,
      scrollableContainerRef,
      onClick,
    }: {
      direction: 'up' | 'down';
      scrollableContainerRef: React.RefObject<HTMLElement> | null;
      onClick?: () => void;
    }) => {
      if (onClick) {
        onClick();
      }

      if (!scrollableContainerRef?.current) {
        return;
      }

      if (direction === 'up') {
        scrollableContainerRef.current.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        const { scrollHeight, clientHeight } = scrollableContainerRef.current;

        scrollableContainerRef.current.scrollTo({
          top: scrollHeight - clientHeight,
          behavior: 'smooth',
        });
      }
    },
    [],
  );

  return useMemo(
    () => ({
      handleScroll,
    }),
    [handleScroll],
  );
};
